/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {PasswordInput} from '@mantine/core';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import notifications from 'notifications';
import EntityStore from 'stores/EntityStore';
import FormGroup from 'ui-library/bs/FormGroup';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {LABEL_STYLES} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';
import ErrorSubclass from 'util/ErrorSubclass';

import createEsignature, {
  EsignatureConfig,
  SIGNATURE_TYPE_AZURE_AD,
  SIGNATURE_TYPE_OKTA,
  SIGNATURE_TYPE_SAML,
} from './createEsignature';
import {ESignatureInfo} from './ReviewConstants';

export class EsignFailureError extends ErrorSubclass {}

interface Props {
  esignatureConfig: EsignatureConfig;
  resolve: (info: ESignatureInfo) => void;
  reject: (...args: Array<any>) => any;
  onRequestClose: (...args: Array<any>) => any;
}

type State = any;

export class OktaEsignModal extends React.Component<Props, State> {
  static close(): void {
    ModalContainer.close(OktaEsignModal);
  }

  static open(props: any): void {
    ModalContainer.open(
      OktaEsignModal,
      <OktaEsignModal
        {...props}
        onRequestClose={() => {
          OktaEsignModal.close();
        }}
      />
    );
  }

  state: State = {
    handle: EntityStore.currentUser().handle,
    password: '',
    submitting: false,
  };

  _handleHandleChange = (e: any): void => {
    this.setState({handle: e.target.value});
  };

  _handlePasswordChange = (e: any): void => {
    this.setState({password: e.target.value});
  };

  _handleReqestClose = (): void => {
    this.props.onRequestClose();
    this.props.reject();
  };

  _handleConfirmPassword = (): void => {
    this.setState({submitting: true});
    createEsignature(this.state.handle, this.state.password, this.props.esignatureConfig)
      .then((signature: ESignatureInfo) => {
        this.props.onRequestClose();
        this.props.resolve(signature);
      })
      .catch(() => {
        notifications.error('Could not verify your password. Please try again.');
      })
      .then(() => {
        this.setState({submitting: false});
      });
  };

  render(): JSX.Element {
    return (
      <Modal
        buttons={[
          {
            text: this.state.submitting ? 'Confirming...' : 'Confirm password',
            style: ButtonStyle.SECONDARY,
            submit: true,
            disabled: !this.state.password || this.state.submitting,
          },
        ]}
        onRequestSubmit={this._handleConfirmPassword}
        onRequestClose={this._handleReqestClose}
        title="Confirm password to e-sign"
      >
        <FormGroup>
          <TextField
            label="Handle"
            labelStyle={LABEL_STYLES.LABEL}
            value={this.state.handle}
            onChange={this._handleHandleChange}
          />
        </FormGroup>
        <FormGroup>
          <PasswordInput
            autoComplete="off"
            autoFocus={true}
            label="Password"
            onChange={this._handlePasswordChange}
            value={this.state.password}
          />
        </FormGroup>
      </Modal>
    );
  }
}

function handleAzureADEsignature(esignatureConfig: any, resolve: any, reject: any): void {
  window.open('/ext/esig/azure-ad-oauth/start', '_blank', 'height=500,width=600');
  reject(); // TODO(BNCH-690): Handle microsoft oauth redirect back
}

// Exported for testing
export function handleSamlEsignature(esignatureConfig: any, resolve: any, reject: any): void {
  const samlWindow = window.open('/ext/esignature/saml:begin', '_blank', 'height=500,width=700');

  // Poll every second to see if the window has closed.
  const timer = setInterval(() => {
    if (samlWindow!.closed) {
      clearInterval(timer);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'samlEsignatureCallback' does not exist o... Remove this comment to see the full error message
      delete window.samlEsignatureCallback;
      reject(
        new EsignFailureError(
          'Authentication window was closed before sign-in was complete. Please try again.'
        )
      );
    }
  }, 1000);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'samlEsignatureCallback' does not exist o... Remove this comment to see the full error message
  window.samlEsignatureCallback = function (message: any) {
    clearInterval(timer);
    samlWindow!.close();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'samlEsignatureCallback' does not exist o... Remove this comment to see the full error message
    delete window.samlEsignatureCallback;
    resolve({
      signature: message,
      signatureType: SIGNATURE_TYPE_SAML,
    });
  };
}

export default function requireEsignature(): Promise<ESignatureInfo | null> {
  if (!BenchlingConfig.ENABLE_ELN_ESIGNATURE) {
    return Promise.resolve(null);
  }
  const esignatureConfig = BenchlingConfig.ELN_ESIGNATURE_CONFIG;
  return new Promise((resolve, reject) => {
    switch (esignatureConfig!.type) {
      case SIGNATURE_TYPE_AZURE_AD:
        handleAzureADEsignature(esignatureConfig, resolve, reject);
        break;
      case SIGNATURE_TYPE_OKTA:
        OktaEsignModal.open({esignatureConfig, resolve, reject});
        break;
      case SIGNATURE_TYPE_SAML:
        handleSamlEsignature(esignatureConfig, resolve, reject);
        break;
      default:
        throw new Error(`Unexpected esignature type (${esignatureConfig!.type})`);
    }
  });
}
